module.exports = __webpack_public_path__ + "static/resume-76252c8c106576527bbbf2b2f6fad363.pdf";